import { Component, h } from '@stencil/core';

@Component({
  tag: 'app-sidenav',
  styleUrl: 'app-sidenav.css'
})
export class AppSidenav {
  menuRef;

  closeMenu() {
    if (this.menuRef && this.menuRef.close) {
      this.menuRef.close();
    }
  }
  openMenu() {
    if (this.menuRef && this.menuRef.open) {
      this.menuRef.open();
    }
  }

  navTo(path) {
    console.log('navTo ' + path);
    this.closeMenu();
    window.location.href = `${path}`;
  }

  renderNavBarOld() {
    return (
      <div class="ion-page">
        <ion-header>
          <ion-toolbar >
            <ion-buttons slot="start">
              <ion-button class="nav-menu-button" onClick={() => this.openMenu()}>
                <ion-icon name="menu"></ion-icon>
              </ion-button>
              {/* <ion-menu-button></ion-menu-button> */}
            </ion-buttons>
            <img slot="start" class="nav-logo" src="assets/svg/logo-horizontal-2.svg" alt="Logo Pager Online"/>
            {/* <ion-title slot="start" {...{ mode: "md" } as any} padding-start class="nav-logo nav-title" color="light">
            </ion-title> */}
            <ion-buttons class="nav-buttons" slot="end">
              {/* <ion-button color="light" href="#landing" class="nav-button-max-width-900">
                Home
              </ion-button> */}
              <ion-button color="dark" href="#signup" class="nav-button-max-width-900">
                Teste Grátis
              </ion-button>
              {/* <ion-button color="light" href="#reasons" class="nav-button-max-width-900">
                Benefícios
              </ion-button> */}
              <ion-button color="dark" href="#intro-video" class="nav-button-max-width-900">
                Vídeo
              </ion-button>
              {/* <ion-button color="dark" href="#clients" class="nav-button-max-width-900">
                Nossos clientes
              </ion-button> */}
              <ion-button color="dark" href="#prices" class="nav-button-max-width-900">
                Preços
              </ion-button>
              <ion-button color="dark" href="#features" class="nav-button-max-width-900">
                Funcionalidades
              </ion-button>
              <ion-button color="dark" href="#contact" class="nav-button-max-width-900">
                Contato
              </ion-button>
              <ion-button color="tertiary" fill="solid" href="https://pager-online.web.app">
                <ion-icon name="globe" slot="start" class="nav-button-icon ion-hide-sm-down"></ion-icon>
                <ion-text class="ion-hide-md-down">Versão Web</ion-text>
                <ion-text class="ion-hide-md-up">Web</ion-text>
              </ion-button>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>

        <slot></slot>
      </div>
    );
  }

  render() {
    return [
      <ion-menu ref={(ref) => this.menuRef = ref} id="mainMenu" contentId="sidenavContent" >
        <ion-header>
          <ion-toolbar color="none">

            <ion-buttons slot="start">
              <ion-button onClick={() => this.closeMenu()}>
                <ion-icon name="close"></ion-icon>
              </ion-button>
            </ion-buttons>

            <img slot="start" class="nav-logo sidenav-logo" src="assets/svg/logo-horizontal-2.svg" alt="Logo Pager Online"/>
          </ion-toolbar>
        </ion-header>

        <ion-content id="sidenavContent" class="sidenav-content">
          <ion-list>

            {/* <div class="ion-activatable ripple-wrapper-div clickable" onClick={() => this.navTo('#landing')}>
              <ion-item lines="none">

                <ion-ripple-effect color="primary"></ion-ripple-effect>
                <ion-icon name="home" color="tertiary" slot="start"></ion-icon>
                <ion-label class="unselectable ion-padding" color="dark" >Home</ion-label>

              </ion-item>
            </div> */}
            <div class="ion-activatable ripple-wrapper-div clickable" onClick={() => this.navTo('https://pager-online.web.app')}>
              <ion-item lines="none">

                <ion-ripple-effect color="primary"></ion-ripple-effect>
                <ion-icon name="globe" color="primary" slot="start"></ion-icon>
                <ion-label class="unselectable ion-padding" color="dark"><b>Versão Web</b></ion-label>

              </ion-item>
            </div>
            <div class="ion-activatable ripple-wrapper-div clickable" onClick={() => this.navTo('#signup')}>
              <ion-item lines="none">

                <ion-ripple-effect color="primary"></ion-ripple-effect>
                <ion-icon name="person-add" color="tertiary" slot="start"></ion-icon>
                <ion-label class="unselectable ion-padding" color="dark">Registre-se para Testar o App</ion-label>

              </ion-item>
            </div>
            <div class="ion-activatable ripple-wrapper-div clickable" onClick={() => this.navTo('#tipos-empresas')}>
              <ion-item lines="none">

                <ion-ripple-effect color="primary"></ion-ripple-effect>
                <ion-icon name="business" color="tertiary" slot="start"></ion-icon>
                <ion-label class="unselectable ion-padding" color="dark">Ideal para o seu negócio</ion-label>

              </ion-item>
            </div>
            {/* <div class="ion-activatable ripple-wrapper-div clickable" onClick={() => this.navTo('#clients')}>
              <ion-item lines="none">

                <ion-ripple-effect color="primary"></ion-ripple-effect>
                <ion-icon name="chatbubbles" color="tertiary" slot="start"></ion-icon>
                <ion-label class="unselectable ion-padding" color="dark" >O que dizem nossos clientes</ion-label>

              </ion-item>
            </div> */}
            {/* <div class="ion-activatable ripple-wrapper-div clickable" onClick={() => this.navTo('#reasons')}>
              <ion-item lines="none">

                <ion-ripple-effect color="primary"></ion-ripple-effect>
                <ion-icon name="information-circle" color="tertiary" slot="start"></ion-icon>
                <ion-label class="unselectable ion-padding" color="dark">Benefícios de usar o Pager Online</ion-label>

              </ion-item>
            </div>             */}
            <div class="ion-activatable ripple-wrapper-div clickable" onClick={() => this.navTo('#intro-video')}>
              <ion-item lines="none">

                <ion-ripple-effect color="primary"></ion-ripple-effect>
                <ion-icon name="play-circle" color="tertiary" slot="start"></ion-icon>
                <ion-label class="unselectable ion-padding" color="dark" >Veja o Vídeo de Introdução</ion-label>

              </ion-item>
            </div>
            <div class="ion-activatable ripple-wrapper-div clickable" onClick={() => this.navTo('#prices')}>
              <ion-item lines="none">

                <ion-ripple-effect color="primary"></ion-ripple-effect>
                <ion-icon name="card" color="tertiary" slot="start"></ion-icon>
                <ion-label class="unselectable ion-padding" color="dark" >Preços</ion-label>

              </ion-item>
            </div>
            <div class="ion-activatable ripple-wrapper-div clickable" onClick={() => this.navTo('#features')}>
              <ion-item lines="none">

                <ion-ripple-effect color="primary"></ion-ripple-effect>
                <ion-icon name="ribbon" color="tertiary" slot="start"></ion-icon>
                <ion-label class="unselectable ion-padding" color="dark" >Funcionalidades</ion-label>

              </ion-item>
            </div>
            <div class="ion-activatable ripple-wrapper-div clickable" onClick={() => this.navTo('#contact')}>
              <ion-item lines="none">

                <ion-ripple-effect color="primary"></ion-ripple-effect>
                <ion-icon name="call" color="tertiary" slot="start"></ion-icon>
                <ion-label class="unselectable ion-padding" color="dark">Contato</ion-label>

              </ion-item>
            </div>


          </ion-list>
        </ion-content>
      </ion-menu>,
      this.renderNavBarOld(),
    ];
  }
}
